// Sticky banner shown while an admin is viewing a company's client side as a
// test member. Provides clear context + an exit affordance.

import React from "react";
import { useSelector } from "react-redux";
import {
  selectIsViewingAsClient,
  selectCompanyName,
} from "../../store/slices/authSlice";
import useExitClientView from "../../hooks/useExitClientView";
import "./ViewAsBanner.css";

export default function ViewAsBanner() {
  const isViewingAsClient = useSelector(selectIsViewingAsClient);
  const companyName = useSelector(selectCompanyName);
  const { exit, isExiting } = useExitClientView();

  if (!isViewingAsClient) return null;

  return (
    <div className="viewas-banner">
      <span className="viewas-banner-text">
        🔍 Viewing <strong>{companyName || "company"}</strong> as an admin test
        member
      </span>
      <button
        className="viewas-banner-exit"
        onClick={exit}
        disabled={isExiting}
      >
        {isExiting ? "Exiting..." : "Exit to Admin"}
      </button>
    </div>
  );
}
